import React from "react";
import logo from "./logo.svg";
import "./App.css";
import GlobalStyles from "./Styles/global";
import { EntidadeProvider } from "./Hooks/EntidadeHook";
import { Rotas } from "./Routes/index.routes";
import { PagamentoProvider } from "./Storage/pagamentos";
function App() {
  return (
    <EntidadeProvider>
      <PagamentoProvider>
        <div className="App">
          <GlobalStyles />
          <Rotas />
        </div>
      </PagamentoProvider>
    </EntidadeProvider>
  );
}

export default App;
